import Icon from "icons"
import styled from "styled-components"
import Video from "components/video"
import { maxWidth } from "utils"

export const Wrapper = styled.div`
  position: relative;
`

export const Content = styled.div`
  padding: 100px;
  background-color: ${({ theme }) => theme.colors.background.footer};

  ${maxWidth.hamburgerLarge`
    padding: 50px 42px;
  `}

  ${maxWidth.mobile`
    padding: 50px 24px;
  `}
`

export const VideoContainer = styled(Video)`
  padding: 0;
`

export const LeafIcon = styled(Icon)`
  position: absolute;
  right: 0;
  bottom: 0;
  transform: scale(0.5);
  transform-origin: bottom right;
  pointer-events: none;
`

export const Metadata = styled.div`
  margin-top: 60px;
`

export const Social = styled.div`
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ShareMenu = styled.div`
  display: flex;
`

export const ShareButton = styled.button`
  display: block;
  margin: 0.5rem;
`

export const Year = styled.div`
  color: #298ff5;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 2px;
`

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.text.alternate};
  font-size: 3rem;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.1px;
`

export const Speakers = styled.div`
  margin: 10px 0 35px;
  color: ${({ theme }) => theme.colors.text.alternate};
  font-size: 1.8rem;
  line-height: 28px;
  letter-spacing: -0.1px;
`

export const Description = styled.div`
  color: ${({ theme }) => theme.colors.text.alternate};
  font-size: 1.8rem;
  line-height: 28px;
  letter-spacing: -0.1px;
`
